import React, { Component } from 'react';
import WhatsappButton from '../../components/WhatsappButton/WhatsappButton';
import './AddTestimonial.css';

import spinner from '../../assets/images/spinner.svg';

class AddTestimonial extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fields: {
        nombre: '',
        email: '',
        testimonio: ''
      },
      loading: false,
      completed: false,
    }
  }

  onInputChange = (evt) => {
    const fields = this.state.fields;
    fields[evt.target.name] =  evt.target.value;
    this.setState({ fields });
  }

  _sendData = () => {
    this.setState({loading: true});
    const { nombre, email, testimonio } = this.state.fields;
    let url = "http://www.usaproductos.com/api/add-testimonio.php?nombre="+nombre+"&email="+email+"&testimonio="+testimonio;
    fetch(url)
      .then(response => response.json())
      .then(function(data){
        let fields = {
          nombre: '',
          email: '',
          testimonio: ''
        }
        this.setState({fields,loading: false, completed: true});
      }.bind(this));
  }

  render() {
    const { loading, completed } = this.state;
    const { nombre, email, testimonio } = this.state.fields;
    return (
      <div className="add-testimonial-container">
        {
          completed &&
          <div className="message">
            <i className="far fa-check-circle"></i>
            Testimonio Recibido
          </div>
        }
        <div className="common-StripeGrid">
          <div className="backgroundContainer">
            <div className="grid">
              <div className="background"></div>
            </div>
          </div>
          <div className="stripeContainer">
            <div className="grid">
              <span className="stripe s1 gray"></span>
              <span className="stripe s2 green1"></span>
              <span className="stripe s4 green2"></span>
              <span className="stripe s6 gray"></span>
              <span className="stripe s7 gray full"></span>
              <span className="stripe s11 green3"></span>
              <span className="stripe s12 green2"></span>
              <span className="stripe s13 green1"></span>
            </div>
          </div>
        </div>
        <div className="container-lg">
          <h1>Contanos cómo te fue</h1>
          <div className="subtitle">
            <span>Hacenos llegar tu experiencia, tus comentarios o lo</span><br/>
            <span>que se te ocurra del servicio de <strong>Usaproductos</strong>.</span>
          </div>
          <div className="box box-name">
            <input type="text" name="nombre" placeholder="Nombre y Apellido" value={nombre} onChange={(evt)=>this.onInputChange(evt)} />
          </div>
          <div className="box box-email">
            <input type="email" name="email" placeholder="Email" value={email} onChange={(evt)=>this.onInputChange(evt)} />
          </div>
          <div className="box box-testimonio">
            <input type="text" name="testimonio" maxLength="140" placeholder="Escribí tus comentarios..." value={testimonio} onChange={(evt)=>this.onInputChange(evt)} />
          </div>
          <button
            className="send-btn"
            disabled={!email || !nombre || !testimonio || loading}
            onClick={()=>this._sendData()}>
            {
              loading &&
              <img src={spinner} alt="Usaproductos" title="Usaproductos" />
            }
            {
              !loading &&
                <span>Enviar</span>
            }
          </button>
        </div>
        <WhatsappButton />
      </div>
    );
  }
}

export default AddTestimonial;



// WEBPACK FOOTER //
// ./src/containers/AddTestimonial/AddTestimonial.js